import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPagePayload } from "../../../pillar/common/actions/LoadPagePayload";

export const QUERY_AVAILABLE_PERMISSIONS = "[SecurityModule] Query Available Permissions";

export class QueryAvailablePermissionsAction implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(public payload: LoadPagePayload) {
    this.type = QUERY_AVAILABLE_PERMISSIONS;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailablePermissionsAction.ts